import { ADMIN_LIST_PAGE_SIZE_OPTIONS } from "@etudescarre/constants";
import { Pagination } from "@etudescarre/ui";

export type AdminListPaginationProps = {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

export function AdminListPagination({
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}: AdminListPaginationProps) {
  const totalPages = Math.ceil(total / pageSize);

  if (total === 0) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="mt-4 flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
      <p className="text-sm text-zinc-500 dark:text-zinc-400">
        {start}–{end} sur {total} résultat{total > 1 ? "s" : ""}
      </p>

      <div className="flex items-center gap-3">
        {totalPages > 1 && (
          <Pagination
            count={total}
            pageSize={pageSize}
            page={page}
            onPageChange={(details) => onPageChange(details.page)}
          />
        )}

        <div className="flex items-center gap-2">
          <label
            htmlFor="admin-page-size"
            className="text-sm text-zinc-600 dark:text-zinc-400"
          >
            Par page:
          </label>
          <select
            id="admin-page-size"
            value={pageSize}
            onChange={(e) => {
              onPageSizeChange(Number(e.target.value));
            }}
            className="rounded-lg border border-zinc-950/10 bg-white px-2 py-1.5 text-sm text-zinc-950 focus:border-blue-600 focus:outline-hidden focus:ring-2 focus:ring-blue-600/20 dark:border-white/15 dark:bg-zinc-900 dark:text-white dark:focus:border-blue-500 dark:focus:ring-blue-500/20"
          >
            {ADMIN_LIST_PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
